// billsSummary.js — the collapsed Bills card line and its default state
// (2026-10-22). Input: annotateBills output (daysUntil, paidThisMonth,
// autopay). "Due" means a bill the user has to act on: unpaid and not autopay.
export const fmtUsd = (n) => `$${Math.round(Number(n) || 0).toLocaleString('en-US')}`;

export function billsSummary(annotated = []) {
  const bills = Array.isArray(annotated) ? annotated.filter(Boolean) : [];
  if (!bills.length) return { line: 'Bills · none yet', dueSoon: 0, overdue: 0, leftThisMonth: 0, allPaid: false };
  const unpaid = bills.filter(b => !b.paidThisMonth);
  const act = unpaid.filter(b => b.autopay !== true);
  const overdue = act.filter(b => b.status === 'overdue' || (b.daysUntil != null && b.daysUntil < 0)).length;
  const dueSoon = act.filter(b => b.daysUntil != null && b.daysUntil >= 0 && b.daysUntil <= 7).length;
  // Money still leaving this month: unpaid bills whose next charge is within ~a month (weekly ones once).
  const leftThisMonth = unpaid.filter(b => b.daysUntil != null && b.daysUntil <= 31).reduce((a, b) => a + (Number(b.amount) || 0), 0);
  if (!unpaid.length) return { line: 'Bills · all paid this month', dueSoon: 0, overdue: 0, leftThisMonth: 0, allPaid: true };
  const parts = ['Bills'];
  if (overdue) parts.push(`${overdue} overdue`);
  if (dueSoon) parts.push(`${dueSoon} due this week`);
  if (!overdue && !dueSoon) parts.push('nothing due this week');
  parts.push(`${fmtUsd(leftThisMonth)} left this month`);
  return { line: parts.join(' · '), dueSoon, overdue, leftThisMonth, allPaid: false };
}

/** Expanded by default only when something needs attention soon (≤7 days) or is overdue. */
export const billsDefaultOpen = (annotated = []) => { const s = billsSummary(annotated); return s.dueSoon > 0 || s.overdue > 0; };

/** The collapsed Subscriptions line; open by default only with unanswered detections to review. */
export function subscriptionsSummary({ total = 0, toReview = 0 } = {}) {
  const line = `Subscriptions ${total % 1 === 0 ? fmtUsd(total) : `$${Number(total).toFixed(2)}`}/mo${toReview ? ` · ${toReview} to review` : ''}`;
  return { line, defaultOpen: toReview > 0 };
}
